type ActiveStatusBadgeProps = {
  active: boolean;
  isArabic: boolean;
};

/**
 * Read-only status pill for list tables (not interactive).
 */
export default function ActiveStatusBadge({ active, isArabic }: ActiveStatusBadgeProps) {
  const on = Boolean(active);
  return (
    <span
      className={`inline-flex min-w-[4.5rem] items-center justify-center rounded-full px-2.5 py-1 text-xs font-semibold ${
        on
          ? "bg-emerald-500/12 text-emerald-800 ring-1 ring-emerald-500/30 dark:bg-emerald-500/14 dark:text-emerald-200 dark:ring-emerald-400/25"
          : "bg-slate-200/95 text-slate-600 ring-1 ring-slate-300/70 dark:bg-white/[0.06] dark:text-slate-300 dark:ring-white/[0.08]"
      }`}
    >
      {on ? (isArabic ? "نشط" : "Active") : isArabic ? "غير نشط" : "Inactive"}
    </span>
  );
}
